var _defs, _path, _rect, _rect2, _rect3, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _rect4, _path16, _rect5, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreistehend = function SvgFreistehend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.875,
    height: 81.856
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "freistehend_svg__a",
    x1: 6.618,
    x2: 63.257,
    y1: 44.562,
    y2: 44.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M15.604 75.042h-9.9v6.814h7.293zM54.271 75.042h9.9v6.814h-7.293z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75.142,
    height: 69.875,
    x: -2.633,
    y: 2.633,
    fill: "#bcc8cc",
    rx: 6,
    transform: "rotate(90 34.938 37.57)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 58.467,
    height: 63.734,
    x: 5.704,
    y: 5.704,
    fill: "#4c6f73",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 61.906,
    height: 56.639,
    x: 3.985,
    y: 9.251,
    fill: "#a0b2b6",
    rx: 3,
    transform: "rotate(90 34.938 37.571)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.996,
    cy: 37.577,
    r: 11.902,
    fill: "#bcc8cc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#freistehend_svg__a)",
    d: "M6.618 31.664v18.157c22.286-8.07 41.986-1.574 56.64 7.638V35.49c-16.266.125-39.736-2.005-56.64-3.825",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M39.975 19.907a1.515 1.515 0 0 0-1.833 1.168l-3.477 12.41 1.606.582 4.97-13.701Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M43.165 22.898a1.515 1.515 0 0 0-.657-2.073l-1.267-.46-4.97 13.702 1.607.583Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M41.241 20.366a1.435 1.435 0 0 0-1.868.951l-3.625 12.56 1.047.38 5.27-11.963a1.435 1.435 0 0 0-.824-1.928"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M17.273 32.534a1.515 1.515 0 0 0 1.169 1.833l12.409 3.477.583-1.606-13.702-4.97Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M20.264 29.344a1.515 1.515 0 0 0-2.072.657l-.46 1.267 13.702 4.97.583-1.607Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M17.732 31.268a1.435 1.435 0 0 0 .952 1.868l12.56 3.625.38-1.047-11.964-5.27a1.435 1.435 0 0 0-1.928.824"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M29.9 55.236a1.515 1.515 0 0 0 1.834-1.169l3.477-12.41-1.607-.582-4.97 13.702Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M26.71 52.245a1.515 1.515 0 0 0 .658 2.072l1.266.46 4.97-13.702-1.607-.583Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M28.634 54.776a1.435 1.435 0 0 0 1.868-.95l3.625-12.561-1.047-.38-5.27 11.964a1.435 1.435 0 0 0 .824 1.927"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M52.602 42.608a1.515 1.515 0 0 0-1.169-1.833l-12.409-3.477-.582 1.607 13.701 4.97Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M49.611 45.799a1.515 1.515 0 0 0 2.073-.658l.459-1.266-13.701-4.97-.583 1.607Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M52.143 43.875a1.435 1.435 0 0 0-.951-1.868l-12.56-3.626-.38 1.047 11.963 5.27a1.435 1.435 0 0 0 1.928-.823"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.996,
    cy: 37.576,
    r: 5.383,
    fill: "#4c6f73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M34.997 41.33a3.754 3.754 0 1 1 3.753-3.753 3.76 3.76 0 0 1-3.753 3.753"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M64.128 27.106v-8.268a.815.815 0 0 1 .815-.815h-1.427a.815.815 0 0 0-.815.815v8.268a.815.815 0 0 0 .815.815h1.427a.815.815 0 0 1-.815-.815"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.887,
    height: 9.897,
    x: 64.128,
    y: 18.023,
    fill: "#a0b2b6",
    rx: 0.815
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M64.128 56.387v-8.268a.815.815 0 0 1 .815-.815h-1.427a.815.815 0 0 0-.815.815v8.268a.815.815 0 0 0 .815.815h1.427a.815.815 0 0 1-.815-.815"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.887,
    height: 9.897,
    x: 64.128,
    y: 47.304,
    fill: "#a0b2b6",
    rx: 0.815
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m6.618 57.986-.111-12.23-.04-12.23-.06-24.485A2.98 2.98 0 0 1 8.353 6.58a4.2 4.2 0 0 1 1.584-.176l1.529.005 6.115.02 12.23.038 12.23.04 12.23.112-12.23.112-12.23.04-12.23.039-6.115.019-1.529.005a3.8 3.8 0 0 0-1.434.158 2.53 2.53 0 0 0-1.64 2.099l-.093 24.436-.04 12.23Z"
  }))));
};
export default SvgFreistehend;